import { j as r } from "./jsx-runtime-3tyXYecC.mjs";
import { cloneElement as d } from "react";
import { f as t } from "./index-LyFokDcn.mjs";
import { m as a } from "./tss-DN0acMKN.mjs";
import { M as m, d as c } from "./constants-CnFYFetN.mjs";
const f = a()(({ constructs: i, palette: e, spacing: o, mode: n }) => ({
  actions: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "flex-end",
    rowGap: o(2),
    columnGap: t.ifFeature("encore", o(2))
  },
  image: {
    fill: e.common.white,
    flex: "0 0 auto"
  },
  root: {
    alignItems: "center",
    backgroundColor: t.ifFeature("encore", i.surface.neutral.xxStrong, e.gray[1e3]),
    boxSizing: "border-box",
    display: "flex",
    gap: o(3),
    minHeight: "118px",
    outline: n === m.Dye ? `2px solid ${c.main}` : void 0,
    padding: o(1.75, 3),
    width: "100%"
  }
})), x = a()(({ palette: i, typography: e, mode: o }) => ({
  root: {
    flexDirection: "column",
    flexGrow: 1,
    outline: o === m.Dye ? `2px solid ${c.main}` : void 0
  },
  subSuperTitle: {
    color: i.common.white,
    fontSize: t.ifFeature("encore", e.teenie.fontSize, e.medium.fontSize),
    lineHeight: t.ifFeature("encore", e.teenie.lineHeight, e.medium.lineHeight)
  },
  title: {
    color: i.common.white,
    fontSize: t.ifFeature("encore", e.h2.fontSize),
    fontWeight: t.ifFeature("encore", e.fontWeightSemibold),
    margin: 0
  }
}));
function h({ subTitle: i, superTitle: e, title: o }) {
  const { classes: n } = x();
  return /* @__PURE__ */ r.jsxs("div", { className: n.root, children: [
    e ? /* @__PURE__ */ r.jsx("div", { className: n.subSuperTitle, children: e }) : null,
    /* @__PURE__ */ r.jsx("h2", { className: n.title, children: o }),
    i ? /* @__PURE__ */ r.jsx("div", { className: n.subSuperTitle, children: i }) : null
  ] });
}
function S({ actions: i, ariaLabel: e, biId: o, children: n, image: s }) {
  const { classes: l } = f();
  return /* @__PURE__ */ r.jsxs("div", { "aria-label": e, className: l.root, "data-bi-id": o, "data-fabric-component": "ActionBanner", role: "region", children: [
    s ? /* @__PURE__ */ r.jsx("div", { className: l.image, children: s }) : null,
    n,
    i ? /* @__PURE__ */ r.jsx("div", { className: l.actions, children: i.map(
      (u) => d(u, {
        dark: !0,
        size: t.ifFeature("encore", "medium", "large")
      })
    ) }) : null
  ] });
}
S.Title = h;
export {
  S as A
};
//# sourceMappingURL=action-banner-H4zKxT2d.mjs.map
